// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"13":"715af22a","336":"09e049cc","460":"c8cc3845"}[chunkId] + ".css";
};